import * as React from "react";
import type { SVGProps } from "react";
const SvgDocSheet = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17}
    height={16}
    fill="none"
    viewBox="0 0 17 16" {...props}
  >
    <path
      stroke="#3079D7"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M6.167 10h4.667M6.167 8h4.667M6.167 6h4.667"
    />
    <path
      stroke="#3079D7"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12.5 13.333h-8a1.333 1.333 0 0 1-1.333-1.334V4c0-.736.597-1.333 1.333-1.333h8c.737 0 1.334.597 1.334 1.333v8c0 .737-.597 1.334-1.334 1.334"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgDocSheet;
